<div class="relative" *transloco="let t">
	<button class="absolute right-2 top-2 z-10" mat-icon-button (click)="close(false)" [attr.aria-label]="t('commonActions.close')">
		<mat-icon>close</mat-icon>
	</button>
	<h1 mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">{{ t('billing.selectBilling') }}</h1>
	<mat-dialog-content>
		<div class="flex flex-col">
			<mat-form-field appearance="fill" class="w-full">
				<mat-label>{{ t('realestates.choose') }}</mat-label>
				<mat-select [formControl]="realEstateFc" (selectionChange)="loadBillings()">
					<mat-select-trigger>
						<div class="font-bold">{{ realEstateFc.value?.area }}/{{ realEstateFc.value?.realEstateNumber }}</div>
						<div class="font-light">{{ realEstateFc.value?.realEstateAddressStreet }},</div>
						<div class="font-light">
							{{ realEstateFc.value?.realEstateAddressZipCode }}
							{{ realEstateFc.value?.realEstateAddressCity }}
						</div>
					</mat-select-trigger>
					@for (realEstate of realEstates(); track realEstate.realEstateId) {
						<mat-option [value]="realEstate">
							<div class="font-bold">{{ realEstate?.area }}/{{ realEstate?.realEstateNumber }}</div>
							<div class="font-light">
								{{ realEstate.realEstateAddressStreet }}, {{ realEstate.realEstateAddressZipCode }} {{ realEstate.realEstateAddressCity }}
							</div>
						</mat-option>
					}
				</mat-select>
			</mat-form-field>
			@if (realEstateFc.value && billings()) {
				@if (billings().length === 0) {
					<mat-error>
						{{ t('quickActions.noBillingsExisting') }}
					</mat-error>
				} @else {
					<mat-form-field appearance="fill" class="w-full">
						<mat-label>{{ t('billing.choose') }}</mat-label>
						<mat-select [formControl]="billingFc">
							<mat-select-trigger>{{ billingFc.value?.billingNumber }} - {{ billingFc.value?.billingName }}</mat-select-trigger>
							@for (billing of billings(); track billing.exportId) {
								<mat-option [value]="billing">
									<div class="font-bold">
										{{ billing.billingName }}
									</div>
									<div class="font-light">
										{{ billing?.billingNumber }}
									</div>
								</mat-option>
							}
						</mat-select>
					</mat-form-field>
				}
			}
		</div>
	</mat-dialog-content>
	@if (this.finishedLoading()) {
		<mat-dialog-actions class="flex flex-row justify-end items-center" mat-dialog-actions>
			<button (click)="close(true)" [disabled]="!billingFc.value" class="m-2" color="primary" mat-raised-button>
				<mat-icon>arrow_forward</mat-icon>
				<span>
					{{ t('commonActions.newCosts') }}
				</span>
			</button>
		</mat-dialog-actions>
	} @else {
		<div class="flex flex-1 flex-row justify-center mb-5">
			<mat-spinner color="primary"></mat-spinner>
		</div>
	}
</div>
